import React from "react";

function Heading({children, ...props}) {
  return (
    <h1 className="text-[30px] font-semibold text-orange-800 text-center" {...props}>{children}</h1>
  );
}

export default Heading;
